import React, { useContext, useState } from 'react';
import { Context } from 'store';
import { PageContainer } from '_src/shared/styles';

import { Card, Button } from 'antd';
import { Refresh, AsyncTable, AsyncModal } from '_src/components';
import services from '_src/services';

import { ButtonContainer } from './styles';

export default () => {
  const { setShown } = useContext(Context);

  const config = services['skillQuestions'];
  const resource = 'skillQuestions';
  const [initialValues, setInitialValues] = useState({});

  const onRowClick = record => {
    setInitialValues({ ...record });
    setShown(resource);
  };

  return (
    <PageContainer>
      <Refresh />
      <Card title={config.title}>
        <ButtonContainer>
          <Button
            type="primary"
            onClick={() => {
              setInitialValues({});
              setShown(resource);
            }}
          >
            {config.createButton}
          </Button>
        </ButtonContainer>
        {/* <AsyncTable
          resource={resource}
          pagination
          config={{
            ...config,
            table: [
              {
                title: 'Aamva Skill Question',
                key: 'question',
                dataIndex: 'question'
              },
              ...config.table
            ]
          }}
          aamva={true}
          onRowClick={onRowClick}
        /> */}
        <AsyncTable
          resource={resource}
          pagination
          config={{
            ...config,
            table: [
              {
                title: 'Skill Question',
                key: 'question',
                dataIndex: 'question'
              },
              ...config.table
            ]
          }}
          // aamva={false}
          onRowClick={onRowClick}
        />
        <AsyncModal
          showDelete={true}
          saveText="Submit"
          title={config.modal.title}
          resource={resource}
          closeModal={() => setShown(resource, false)}
          initialValues={initialValues}
        ></AsyncModal>
      </Card>
    </PageContainer>
  );
};
